import { createContext, useContext, useReducer } from "react";
import { reducerFunction, state ,getUserDetails, editUserDetails, getUserDetailsByRegId, editAdminSelf, editStudentByAdmin} from "./UserHelper";

const UserContext = createContext({})

export const UserProvider = ({ children }) => {

    const [userState, userDispatch] = useReducer(reducerFunction, state)
    return <UserContext.Provider value={{ userState, userDispatch, getUserDetails ,editUserDetails,getUserDetailsByRegId,editAdminSelf,editStudentByAdmin}}>
        {children}
    </UserContext.Provider>
}
export const useUser = () => useContext(UserContext)